import type { SVGProps } from "react";
import * as React from "react";
const SvgAi21 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#Ai21_svg__a)">
      <path
        fill="#000"
        d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.66 14.116c-.44.816-.66 1.894-.66 3.233h8.366v-2.155H8.2c.108-.382.258-.686.45-.915.205-.229.542-.473 1.014-.735l1.625-.882c.708-.37 1.244-.843 1.609-1.42a3.566 3.566 0 0 0 .563-1.96c0-1.023-.354-1.823-1.062-2.4C11.693 6.294 10.711 6 9.456 6c-.836 0-1.576.163-2.22.49a3.598 3.598 0 0 0-1.48 1.388c-.343.599-.515 1.295-.515 2.09h2.655c0-.62.134-1.094.402-1.42.279-.338.67-.507 1.174-.507.397 0 .714.125.95.376.246.24.37.56.37.963 0 .751-.403 1.34-1.207 1.764l-1.754.93c-1.008.534-1.732 1.214-2.171 2.042Zm8.433-3.789h2.317v7.022H19V6.245h-2.252c0 .49-.076.876-.226 1.16-.139.282-.402.495-.788.636-.386.142-.933.213-1.64.213v2.073Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Ai21_svg__a">
        <rect width={24} height={24} fill="#fff" rx={4} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAi21;
